import React, { useState } from 'react';
import { MetaDataBox } from './hearingInfoBox/MetaDataBox';
import { ContactInfoBox } from './hearingInfoBox/ContactInfoBox';
import { getAttr, getEntityId } from '../../../features/helpers/apiHelpers';
import { useSelector } from 'react-redux';
import { subjectAreaByHearingIdSelector } from '../../../features/apiFeatures/subjectAreaSlice';
import { hearingTypeByHearingIdSelector } from '../../../features/apiFeatures/hearingTypeSlice';
import { hearingStatusByHearingIdSelector } from '../../../features/selectors/compositeSelectors';
import { cityAreaByHearingIdSelector } from '../../../features/apiFeatures/cityAreaSlice';
import { copyExternalHearingLinkToClipboard } from '../../../utilities/clipboard';

const HearingInfoBox = ({ hearing, disableTitle, showEmptyValues }) => {
  const hearingId = getEntityId(hearing);
  const subjectArea = useSelector(subjectAreaByHearingIdSelector(hearingId));
  const cityArea = useSelector(cityAreaByHearingIdSelector(hearingId));
  const hearingType = useSelector(hearingTypeByHearingIdSelector(hearingId));
  const hearingStatus = useSelector(
    hearingStatusByHearingIdSelector(hearingId),
  );

  const [didCopyHearingLink, setDidCopyHearingLink] = useState(false);
  const [didCopyHearingLinkTimer, setDidCopyHearingLinkTimer] = useState(null);

  const copyHearingLink = (e) => {
    e.preventDefault();
    if (hearingId) {
      copyExternalHearingLinkToClipboard(hearingId);
      setDidCopyHearingLink(true);

      if (didCopyHearingLinkTimer) {
        clearTimeout(didCopyHearingLinkTimer);
      }
      setDidCopyHearingLinkTimer(
        setTimeout(() => setDidCopyHearingLink(false), 3000),
      );
    }
  };

  return (
    <div className="create-hearing-info-box" id="create-hearing-info-box">
      <MetaDataBox
        subjectAreaName={getAttr(subjectArea, 'name')}
        cityAreaName={getAttr(cityArea, 'name')}
        hearingTypeName={getAttr(hearingType, 'name')}
        hearingStatus={getAttr(hearingStatus, 'status')}
        startDate={getAttr(hearing, 'startDate')}
        deadline={getAttr(hearing, 'deadline')}
        esdhNumber={getAttr(hearing, 'esdhNumber')}
        hearingTitle={!disableTitle && '-'}
        copyHearingLink={copyHearingLink}
        didCopyHearingLink={didCopyHearingLink}
      />
      <ContactInfoBox
        departmentName={getAttr(hearing, 'contactPersonDepartmentName')}
        email={getAttr(hearing, 'contactPersonEmail')}
        phoneNumber={getAttr(hearing, 'contactPersonPhoneNumber')}
        contactPerson={getAttr(hearing, 'contactPersonName')}
        showEmptyValues={showEmptyValues}
      />
    </div>
  );
};

export { HearingInfoBox };
